module.exports = __webpack_public_path__ + "media/audio8.be3bad99.mp3";